/**
 * Onboarding state — Zustand local store.
 *
 * Garde en memoire (avant signup serveur) :
 *   - aiDisclosureAcknowledgedAt : timestamp a logger cote backend dans
 *     consent_log avec ai_act_disclosure_version
 *   - ageBand : selectionne a l'ecran 2 (gate 18+)
 *   - email + consentCgu a l'ecran 3
 *
 * Persistance : sessionStorage (utiliser puis flush au signup reussi).
 *
 * Wave M2-mobile-polish (C4) : simplification UX consent. 1 seul flag
 * consentCgu (acceptation CGU + politique de confidentialite) au lieu de
 * 2 flags consentHealthData + consentResearch.
 */
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
const initialState = {
    aiDisclosureAcknowledgedAt: null,
    aiActDisclosureVersion: 'v1.0',
    ageBand: null,
    email: '',
    consentCgu: false,
};
export const useOnboardingStore = create()(persist((set) => ({
    ...initialState,
    setAIDisclosureAcknowledged: () => set({ aiDisclosureAcknowledgedAt: new Date().toISOString() }),
    setAgeBand: (ageBand) => set({ ageBand }),
    setEmail: (email) => set({ email }),
    setConsentCgu: (consentCgu) => set({ consentCgu }),
    reset: () => set({ ...initialState }),
}), {
    name: 'labrain.onboarding.draft',
    storage: createJSONStorage(() => sessionStorage),
    partialize: (state) => ({
        aiDisclosureAcknowledgedAt: state.aiDisclosureAcknowledgedAt,
        aiActDisclosureVersion: state.aiActDisclosureVersion,
        ageBand: state.ageBand,
        email: state.email,
        consentCgu: state.consentCgu,
    }),
}));
//# sourceMappingURL=onboardingStore.js.map